// wev/src/api/widget/WidgetAPI.ts
import { AxiosInstance } from 'axios';

export default class WidgetAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async MyTotalPortfolioValueWidget({
    userId,
    currencyId,
  }: {
    userId: string;
    currencyId: string;
  }) {
    return this.client.get(
      `/widget/get-total-portfolio-value?user_id=${userId}&currency_id=${currencyId}`,
    );
  }

  async MyPortfolioReportsWidget() {
    // return this.client.get(
    //   `/widget/get-portfolio-reports?user_id=${user_id}`,
    // );

    return ['a', 'b', 'c'];
  }
}
